export function isDashed(dashedWhenDisabled: boolean): string {
	return dashedWhenDisabled ? 'dashed' : 'solid'
}
